import React, { useState } from 'react';

const REASONS = ['Conference Exhibitor', 'Conference Attendee', 'Client Onsite', 'NA'];

interface Props {
  employeeName: string;
  title: string;
  startDate: string;
  endDate: string;
  reason: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
}

const styles: Record<string, React.CSSProperties> = {
  form: { maxWidth: 500 },
  field: { marginBottom: 20 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 },
  labelRequired: { display: 'block', fontSize: 13, fontWeight: 600, color: '#e53e3e', marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #cbd5e0', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' },
  inputError: { width: '100%', padding: '10px 12px', border: '2px solid #e53e3e', borderRadius: 4, fontSize: 14, boxSizing: 'border-box', background: '#fff5f5' },
  select: { width: '100%', padding: '10px 12px', border: '1px solid #cbd5e0', borderRadius: 4, fontSize: 14, boxSizing: 'border-box', background: 'white' },
  selectError: { width: '100%', padding: '10px 12px', border: '2px solid #e53e3e', borderRadius: 4, fontSize: 14, boxSizing: 'border-box', background: '#fff5f5' },
  row: { display: 'flex', gap: 16 },
  btn: { background: '#0078d4', color: 'white', border: 'none', padding: '12px 24px', borderRadius: 6, fontSize: 15, cursor: 'pointer', fontWeight: 600, marginTop: 12 },
  requiredHint: { fontSize: 11, color: '#e53e3e', marginTop: 4 },
};

export default function DateRangeStep({ employeeName, title, startDate, endDate, reason, onChange, onNext }: Props) {
  const [attempted, setAttempted] = useState(false);
  const canProceed = employeeName && title && startDate && endDate && reason;

  const handleNext = () => {
    if (!canProceed) {
      setAttempted(true);
      return;
    }
    onNext();
  };

  const isEmpty = (val: string) => attempted && !val;

  return (
    <div style={styles.form}>
      <div style={styles.field}>
        <label style={isEmpty(employeeName) ? styles.labelRequired : styles.label}>
          Employee Name {isEmpty(employeeName) && '*'}
        </label>
        <input
          style={isEmpty(employeeName) ? styles.inputError : styles.input}
          value={employeeName}
          onChange={(e) => onChange('employeeName', e.target.value)}
        />
        {isEmpty(employeeName) && <div style={styles.requiredHint}>Required</div>}
      </div>
      <div style={styles.field}>
        <label style={isEmpty(title) ? styles.labelRequired : styles.label}>
          Report Title {isEmpty(title) && '*'}
        </label>
        <input
          style={isEmpty(title) ? styles.inputError : styles.input}
          value={title}
          placeholder="e.g. GIS Conference - Denver 2026"
          onChange={(e) => onChange('title', e.target.value)}
        />
        {isEmpty(title) && <div style={styles.requiredHint}>Required</div>}
      </div>
      <div style={styles.row}>
        <div style={{ ...styles.field, flex: 1 }}>
          <label style={isEmpty(startDate) ? styles.labelRequired : styles.label}>
            Start Date {isEmpty(startDate) && '*'}
          </label>
          <input
            style={isEmpty(startDate) ? styles.inputError : styles.input}
            type="date"
            value={startDate}
            onChange={(e) => onChange('startDate', e.target.value)}
          />
          {isEmpty(startDate) && <div style={styles.requiredHint}>Required</div>}
        </div>
        <div style={{ ...styles.field, flex: 1 }}>
          <label style={isEmpty(endDate) ? styles.labelRequired : styles.label}>
            End Date {isEmpty(endDate) && '*'}
          </label>
          <input
            style={isEmpty(endDate) ? styles.inputError : styles.input}
            type="date"
            value={endDate}
            min={startDate || undefined}
            onChange={(e) => onChange('endDate', e.target.value)}
          />
          {isEmpty(endDate) && <div style={styles.requiredHint}>Required</div>}
        </div>
      </div>
      <div style={styles.field}>
        <label style={isEmpty(reason) ? styles.labelRequired : styles.label}>
          Reason {isEmpty(reason) && '*'}
        </label>
        <select
          style={isEmpty(reason) ? styles.selectError : styles.select}
          value={reason}
          onChange={(e) => onChange('reason', e.target.value)}
        >
          <option value="">Select...</option>
          {REASONS.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        {isEmpty(reason) && <div style={styles.requiredHint}>Required</div>}
      </div>
      <button style={styles.btn} onClick={handleNext}>Next: Import Receipts</button>
    </div>
  );
}
